import CloseIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Close.js';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

interface FormUnpublishedModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  variant?: 'deactivate' | 'reactivate';
}

const TITLE_ID = 'form-unpublished-modal-title';

const COPY = {
  deactivate: {
    title: 'Unpublish form',
    body: 'Are you sure you want to unpublish form?',
    bullets: [] as React.ReactElement[],
  },
  reactivate: {
    title: 'Activate category',
    body: 'Are you sure you want to activate category? Turning on configurations will have the following impact:',
    bullets: [
      <>
        Category <strong>will be available for selection</strong> by reporters
      </>,
      <>
        <strong>Form</strong> created for this category{' '}
        <strong>gets published</strong>
      </>,
    ],
  },
};

export const FormUnpublishedModal: React.FC<FormUnpublishedModalProps> = ({
  open,
  onClose,
  onConfirm,
  variant = 'deactivate',
}) => {
  const copy = COPY[variant];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={TITLE_ID}
      data-testid="form-unpublished-modal"
    >
      <DialogTitle component="div">
        <Typography variant="h6" component="h2" id={TITLE_ID}>
          {copy.title}
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="Close"
          size="small"
          color="inherit"
          data-testid="form-unpublished-close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: copy.bullets.length ? '12px' : 0 }}>
          {copy.body}
        </Typography>
        {copy.bullets.length > 0 && (
          <Box component="ul" sx={{ pl: '20px', m: 0 }}>
            {copy.bullets.map((bullet, i) => (
              <li key={i}>{bullet}</li>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button
          variant="outlined"
          onClick={onClose}
          data-testid="form-unpublished-cancel-button"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color={variant === 'deactivate' ? 'destructive' : 'primary'}
          onClick={onConfirm}
          autoFocus
          data-testid="form-unpublished-continue-button"
        >
          {variant === 'deactivate' ? 'Unpublish' : 'Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
